<!--
================================================================================
  Template (HTML)
================================================================================
-->

<template>
  <base-layout mw1>
    <v-col cols="12">
      <template-create-update
        :template-data="{id}"
        @success="back"
        @cancel="back"/>
    </v-col>
  </base-layout>
</template>

<!--
================================================================================
  Logic (JavaScript)
================================================================================
-->

<script>
  import TemplateCreateUpdate from './TemplateCreateUpdate'
  import BaseLayout from '@/app/core/components/BaseLayout'

  export default {
    name: 'TemplateEdit',

    components: {
      BaseLayout,
      TemplateCreateUpdate
    },

    props: {
      id: {
        type: [Number, String],
        default: undefined
      }
    },

    methods: {
      back () {
        this.$router.back ()
      }
    }
  }
</script>
